import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Paper, Card, CardContent, Grid, Button,TextField,MenuItem,InputAdornment } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";

import CreateModal from "./ModalCreate";
import TransportersList from "./TransportersList";

import transportersActions from "../../../redux/actions/transporters";
import regProvComsData from "../../../resources/regProvCom";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

function TransportersPage(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const transporters = useSelector((state) => state.transporters);

  const [createModal, setCreateModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [search, setSearch] = React.useState("")
  const [filteredTransporters, setFilteredTransporters] = React.useState(transporters);
  const [communes] = useState([]);

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const getCommuneName = (code) => {
    return communes.filter((commune) => commune.code === code)[0].name;
  };

  useEffect(() => {
    // const start = async () => {
    dispatch(transportersActions.fetchTransporters());
    // };
    // start();
    regProvComsData.forEach(regionsElements => {
      regionsElements.provincias.forEach(provinceElement => {
        provinceElement.comunas.forEach(communeElement => {
          communes.push({
            name: communeElement.name,
            code: communeElement.code,
            regCode: regionsElements.region_iso_3166_2,
            provCode: provinceElement.name,
          })
        })
      })
    })
  }, []);

  useEffect(() => {
    setFilteredTransporters(() => {
      const currentTransporters = transporters.transporters ? transporters.transporters : [];
      const filtered = currentTransporters.filter((transporter) =>
        transporter.name.trim().toLowerCase().includes(search.toLowerCase()) ||
        transporter.lastName.trim().toLowerCase().includes(search.toLowerCase()) ||
        transporter.address.trim().toLowerCase().includes(search.toLowerCase()) ||
        transporter.company.trim().toLowerCase().includes(search.toLowerCase()) ||
        (transporter.name.trim() + " " + transporter.lastName.trim()).toLowerCase().includes(search.toLowerCase()) ||
        getCommuneName(transporter.commune).toLowerCase().includes(search.toLowerCase()) ||
        (transporter.address.trim() + " ," + getCommuneName(transporter.commune)).toLowerCase().includes(search.toLowerCase())
      );
      return {...transporters, transporters: filtered };
    });
  }, [transporters, search]);

  return (
    <Paper className={classes.root}>
      {createModal && (
        <CreateModal setOpen={setCreateModal} />
      )}
      <Card>
        <CardContent>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Grid item>
              <div>
                <h3>Transportistas</h3>
              </div>
            </Grid>
            <Grid item>
              <Button
                onClick={() => setCreateModal(true)}
                color="primary"
                size="small"
                variant="contained"
                startIcon={<AddCircleOutlineIcon />}
              >
                Agregar Transportista
              </Button>
            </Grid>
          </Grid>
          <hr></hr>
          <div style={{ padding: "16px" }}>
            <TextField
              label="Buscar"
              variant="outlined"
              size="small"
              fullWidth
              value={search}
              onChange={handleSearchChange}
              placeholder="Buscar por empresa, direccion o nombre del transportista"
            />
          </div>
          <TransportersList
            transporters={filteredTransporters}
            editData={editData}
            setEditData={setEditData}
          />
        </CardContent>
      </Card>
    </Paper>
  );
}

export default TransportersPage;
